namespace $.$$ {

	$mol_style_define( $shm_wordstat_filter_panel, {
		
		Filter_reset: {
			flex: {
				grow: 0,
				shrink: 0,
			},
			margin: {
				left: 'auto',
			},
		},

		Foot: {
			padding: $mol_gap.block,
		},

		Filters: {
			minWidth: 0,
			display: 'grid',
			gap: '18px',
		},

		Period_section: {
			flex: {
				direction: 'row',
			},
			Title: {
				display: 'flex',
			},
		},

		Query_section: {
			Label: {
				width: '100%',
			},
		},

		Query_all: {
			margin: {
				left: 'auto',
			},
			flex: {
				shrink: 0,
			},
		},

		Query_hint: {
			color: $mol_theme.shade,
			font: {
				size: $mol_style_unit.px( 12 ),
				weight: 'normal',
			},
			whiteSpace: 'normal',
		},

		Period_kind_section: {
		},

		Period_kind_check: {
			'[disabled]': {
				true: {
					color: $mol_theme.shade,
				},
			},
		},

		Period_kind_radio: {
			'[disabled]': {
				true: {
					color: $mol_theme.shade,
				},
			},
		},

		Devices_section: {
			Label: {
				width: '100%',
			},
		},

		Device_group_all: {
			margin: {
				left: 'auto',
			},
			flex: {
				shrink: 0,
			},
		},

		Device_all: {
			'[disabled]': {
				true: {
					color: $mol_theme.shade,
				},
			},
		},

		Device_desktop: {
			'[disabled]': {
				true: {
					color: $mol_theme.shade,
				},
			},
		},

		Device_phone: {
			'[disabled]': {
				true: {
					color: $mol_theme.shade,
				},
			},
		},

		Device_tablet: {
			'[disabled]': {
				true: {
					color: $mol_theme.shade,
				},
			},
		},

		Queries: {
			minWidth: 0,
		},

		Query_checks: {
			minWidth: 0,
			flex: {
				direction: 'column',
			},
		},

		Query_row: {
			position: 'relative',
			minWidth: 0,
			':hover': {
				['Query_only' as '$mol_view']: {
					opacity: 1,
					pointerEvents: 'auto',
				},
			},
		},

		Query_check: {
			minWidth: 0,
			justifyContent: 'flex-start',
			flex: {
				grow: 1,
				shrink: 1,
			},
			Title: {
				minWidth: 0,
				whiteSpace: 'normal',
				overflowWrap: 'anywhere',
				wordBreak: 'break-word',
			},
		},

		Query_only: {
			opacity: 0,
			pointerEvents: 'none',
			position: 'absolute',
			right: 0,
			height: '100%',
			minHeight: 0,
			minWidth: 0,
			zIndex: $mol_layer.hover,
			background: {
				color: $mol_theme.back,
			},
			padding: {
				left: $mol_style_unit.px( 6 ),
				right: $mol_style_unit.px( 6 ),
				top: $mol_style_unit.px( 2 ),
				bottom: $mol_style_unit.px( 2 ),
			},
			font: {
				size: $mol_style_unit.px( 12 ),
			},
		},

		Period: {
			gap: 0,
		},

		Period_kinds: {
			minWidth: 0,
			flex: {
				direction: 'row',
			},
		},

		Run: {
			width: '100%',
			justifyContent: 'center',
		},

	} )

}
